export default "__VITE_ASSET__feeac1c7__"